<script setup lang="ts">
const { t } = useTexts();
const { isUserV2Enabled } = useFeatureFlagsJson();

useSeo({
  title: t('account.wallet.transactions.title'),
});
</script>

<template>
  <UserV2ScreenTransactionsHistory v-if="isUserV2Enabled" />
  <UserAccountPageLayout
    v-else
    on-back="user-wallet"
    :title="$t('account.wallet.transactions.title')"
  >
    <div :class="$style.walletTransactions">
      <UserWalletTransactions :only-wallet-transactions="true" />
    </div>
  </UserAccountPageLayout>
</template>

<style module lang="scss">
.walletTransactions {
  @apply w-full h-auto m-0 max-w-[792px];
}
</style>
